import { Box, CircularProgress } from '@mui/material';

export const renderWithLoader = (Component, isLoading) => {
  return (
    <Box
      sx={{
        width: '60px',
        height: '60px',
        background: '#F4F5F2',
        border: '1px solid #D1D1D1',
        borderRadius: '8px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <Component />

      {isLoading && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#FFFFFF',
          }}
        >
          <CircularProgress color="inherit" size={24} />
        </Box>
      )}
    </Box>
  );
};
